import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Skeleton,
} from '@mui/material'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAngleDown } from '@fortawesome/free-solid-svg-icons'
import { useState, ReactNode } from 'react'

interface AccordionWrapperProps {
  title: string
  variant?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'body1' | 'body2'
  children: ReactNode
  expanded?: boolean
  isLoading?: boolean
}

const AccordionWrapper = ({
  title,
  variant = 'h4',
  children,
  expanded = false,
  isLoading,
}: AccordionWrapperProps) => {
  const [isExpanded, setIsExpanded] = useState(expanded)

  return (
    <Accordion
      expanded={isExpanded}
      onChange={() => setIsExpanded((prev) => !prev)}
      sx={{ bgcolor: 'grey.100' }}
    >
      <AccordionSummary
        sx={{ px: 5 }}
        expandIcon={<FontAwesomeIcon icon={faAngleDown} />}
      >
        {isLoading ? (
          <Skeleton variant="text" sx={{ fontSize: '40px', width: '150px' }} />
        ) : (
          <Typography variant={variant}>{title}</Typography>
        )}
      </AccordionSummary>
      {!isLoading ? <AccordionDetails>{children}</AccordionDetails> : null}
    </Accordion>
  )
}

export default AccordionWrapper
